import AOS from 'aos';
import 'aos/dist/aos.css';

class ActivateAOS {
    // 1. describe and create/initiate our object
    constructor() {
        AOS.init();
    }
}

export default ActivateAOS;
